import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <span>{t('footer-copyright')}</span>
          </div>
          <div className="footer-bottom-right">
            <Link to="/privacy-policy">{t('footer-privacy')}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 